import {
  ANALYTICAL_EXPERIENCE_COOKIES_GROUP,
  CONSENT_TRUE_FLAG,
  COOKIE_PREFERENCES_COOKIE,
  FUNCTIONAL_COOKIES_GROUP,
  PERFORMANCE_COOKIES_GROUP,
  TARGETING_ADVERTISING_COOKIES_GROUP,
  TECHNICAL_COOKIES_GROUP,
} from '../constants';

export interface CookieObj {
  [key: string]: string;
}

const acceptsGroupIdCookies = (groupId: string) => (cookieObj: CookieObj) => {
  const cookieValue = cookieObj[COOKIE_PREFERENCES_COOKIE] || '';
  const regExp = /groups=([^&]+)/;
  const oneTrustCookieMatches = cookieValue.match(regExp);
  return Boolean(oneTrustCookieMatches?.[1].includes(`${groupId}:${CONSENT_TRUE_FLAG}`));
};

export const acceptsAnalyticalExperienceCookies = acceptsGroupIdCookies(
  ANALYTICAL_EXPERIENCE_COOKIES_GROUP,
);
export const acceptsFunctionalCookies = acceptsGroupIdCookies(FUNCTIONAL_COOKIES_GROUP);
export const acceptsPerformanceCookies = acceptsGroupIdCookies(PERFORMANCE_COOKIES_GROUP);
export const acceptsTargetingAdvertisingCookies = acceptsGroupIdCookies(
  TARGETING_ADVERTISING_COOKIES_GROUP,
);
export const acceptsTechnicalCookies = acceptsGroupIdCookies(TECHNICAL_COOKIES_GROUP);
